<p-toast></p-toast>
<div class="col-12">
    <div class="card" reflow="true">
        <h5 class=" ">{{ "CHANGE_VENDOR/PROGRAMME" | translate }}</h5>
        <div class="card applicationDetails">
            <div>
                <form [formGroup]="applicationForm" (ngSubmit)="submitApplication()">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-4">
                            <label>{{ "APPLICATION_NUMBER" | translate }}</label>
                            <!-- <input [readOnly]="hideAppDetailsArea" pInputText id="applicationNo" type="text"
                                formControlName="applicationNo" [ngClass]="{
                                'ng-invalid ng-dirty': isSubmitted && f.applicationNo.errors
                                }" placeholder="{{ 'ENTER_APPLICATION_NUMBER' | translate }}" /> -->
                            <p-dropdown [options]="farmerAppDetails" optionLabel="appID" optionValue="appID" 
                                formControlName="applicationNo" placeholder="{{'SELECT_APPLICATION_ID'| translate}}"
                                [disabled]="hideAppDetailsArea">
                            </p-dropdown>
                            <a *ngIf="!f.applicationNo.errors" class="my-2" style="cursor: pointer;"
                                (click)="clearAppNo()">{{ "CLEAR_APPLICATION_NO" | translate }}</a>
                            <div *ngIf="isSubmitted && f.applicationNo.errors" class="invalid-feedback">
                                <div *ngIf="f.applicationNo.errors.required">
                                    {{ "APPLICATION_NO_IS_REQUIRED" | translate }}
                                </div>
                            </div>
                        </div>

                        <div *ngIf="showStatusArea" class="field col-12 md:col-4">
                            <label>{{'PROGRAMME_NAME'| translate}}
                            </label>
                            <p-dropdown [options]="selectedProgramList" formControlName="programId"
                                placeholder="{{'SELECT_PROGRAMME_NAME'| translate}}" optionLabel="Program_Name"
                                optionValue="Program_Id" (onChange)="getChangeProgram($event)"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.programId.errors}"
                                [disabled]="true">
                            </p-dropdown>
                            <div *ngIf="isSubmitted && f.programId.errors" class="invalid-feedback">
                                <div *ngIf="f.programId.errors.required">{{'PROGRAM_NAME_IS_REQUIRED'| translate}}
                                </div>
                            </div>
                        </div>

                        <!-- <div class="field col-12 md:col-3">
                            <label>{{'Remarks'| translate}}
                            </label>
                            <textarea id="description" [(ngModel)="statusMessage" placeholder="{{'REMARKS'| translate}}" pInputTextarea required rows="3" cols="20" class="mr-3" [ngClass]="{ 'ng-invalid ng-dirty': (isSubmitted  || f.remarks.touched) && f.remarks.errors }"></textarea>
                            <div *ngIf="(isSubmitted || f.remarks.touched) && f.remarks.errors" class="invalid-feedback">
                                <div *ngIf="f.remarks.errors.required">{{'REMARK_IS_REQUIRED'| translate}}
                                </div>
                            </div>
                        </div> -->

                        <div *ngIf="(!hideAppDetailsArea) || (showStatusArea && !isAppEditable)"
                            class="field col-12 md:col-2">
                            <label>{{ "" | translate }}</label>
                            <button pButton pRipple type="submit" label="{{ 'CHECK_STATUS' | translate }}"
                                class="p-button-success m-2"></button>
                        </div>
                    </div>
                </form>
            </div>

            <div *ngIf="showStatusArea" class="after-status-check">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-6">
                        <span style="font-weight: bold;">Status: <span
                                style="font-weight: bold; color: 'rgb(168, 32, 32)'">{{ statusMessage }}</span></span>
                    </div>
                </div>

                <div *ngIf="isAppEditable" class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-4">
                        <label>{{'ACTION_TYPE'| translate}}
                        </label>
                        <p-dropdown [options]="actionMasterList" [(ngModel)]="actionType"
                            placeholder="{{'SELECT_ACTION_TYPE'| translate}}" optionLabel="ActionName"
                            optionValue="Action_ID" (onChange)="onChangeActionType($event)">
                        </p-dropdown>
                    </div>

                    <div *ngIf="actionType == 3" class="field col-12 md:col-4">
                        <label>{{'NEW_PROGRAMME_NAME'| translate}}
                        </label>
                        <p-dropdown [options]="pogramNameList" [(ngModel)]="updatedProgramId"
                            placeholder="{{'SELECT_PROGRAMME_NAME'| translate}}" optionLabel="Program_Name"
                            optionValue="Program_Id">
                        </p-dropdown>
                    </div>

                    <div *ngIf="actionType == 2" class="field col-12 md:col-4">
                        <label>{{'NEW_VENDOR_NAME'| translate}}
                        </label>
                        <p-autoComplete placeholder="{{'SELECT_VENDOR_NAME'| translate}}" id="dd" [dropdown]="true"
                            [multiple]="false" optionLabel="Name" optionValue="Vendor_Code"
                            [suggestions]="filteredVendorList" (completeMethod)="filterMIVendor($event)" field="Name"
                            (onSelect)="onVendorSelect($event)" [(ngModel)]="updatedVendorId"></p-autoComplete>
                    </div>

                    <!-- <div class="field col-12 md:col-2">
                        <label>{{ "" | translate }}</label>
                        <button pButton pRipple type="button" label="{{ 'CANCEL' | translate }}"
                            class="p-button-secondary" (click)="cancelChangeRequest()"></button>
                    </div>

                    <div class="field col-12 md:col-2">
                        <label>{{ "" | translate }}</label>
                        <button pButton pRipple type="button" label="{{ 'SUBMIT' | translate }}"
                            class="p-button-success" (click)="submitChangeRequest()"></button>
                    </div> -->

                    <div class="field col-12 md:col-4">
                        <label htmlFor="block">{{'Upload Doc' | translate}}</label>
                        <div class="flex">
                            <p-fileUpload accept=".jpeg,.pdf,.jpg" #supportingFileUpload [customUpload]="true"
                                (uploadHandler)="onUpload($event, 'docPath', supportingFileUpload)" name="myfile[]"
                                mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}"
                                [auto]="true">
                            </p-fileUpload>
                            <p-image [src]="supportingDocPath" [preview]="true" alt="Image"
                                width="60" class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>
                        </div>
                        <!-- <div *ngIf="isSubmitted && f.docPath.errors" class="invalid-feedback">
                            <div *ngIf="f.docPath.errors.required">{{'Supporting Doc is required' |
                                translate}}</div>
                        </div> -->
                    </div>
                </div>

                <button *ngIf="isAppEditable" pButton pRipple type="button" label="{{ 'SUBMIT' | translate }}"
                    class="p-button-success mx-3" (click)="submitChangeRequest()"></button>
                <button *ngIf="isAppEditable" pButton pRipple type="button" label="{{ 'CANCEL' | translate }}"
                    class="p-button-secondary" (click)="cancelChangeRequest()"></button>

            </div>
        </div>
    </div>
</div>